<template>
  <div>
    <el-row>
      <el-col :md="12" :sm="24">
        <el-input size="small" placeholder="请输入名称搜索" v-model="searchName" class="input-with-select">
          <el-button type="primary" slot="append" icon="el-icon-search" @click="search">搜索</el-button>
        </el-input>
      </el-col>
    </el-row>
    <div style="height: 20px"></div>
    <datatable
      :highlight="true"
      :loading="loading"
      :height="400"
      :tableQuery="tableQuery"
      :tableData="tableData"
      @table-current-change="handleCurrentChange"
      @current-change="tableQuery.page=$event, search()"
      @size-change="tableQuery.size=$event, search()">
      <el-table-column label="选择" width="60">
        <template slot-scope="scope">
          <a-checkbox @change="handleCurrentChange(scope.row)" :checked="scope.row.checkd"></a-checkbox>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="项目名称" prop="projectName"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="地区">
        <template slot-scope="scope">
          {{scope.row.province}} {{scope.row.city}} {{scope.row.area}}
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="物业公司" prop="other.customerName"></el-table-column>
    </datatable>
    <div style="text-align: right;margin-top: 20px">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button type="primary" size="small" @click="ok">确定</el-button>
    </div>
  </div>
</template>
<script>
import { listProject } from '@/api/resource'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  props: {
    fanwei: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      searchName: '',
      loading: true,
      tableData: {
        aaData: []
      },
      tableQuery: {
        page: 0,
        size: 5,
        filter: '',
        order: ''
      },
      val: {
        id: '0'
      }
    }
  },
  created () {
    this.search()
  },
  methods: {
    search () {
      this.loading = true
      // fanwei 1我自己的 2公司所有的
      if (this.fanwei === 1) {
        this.tableQuery.filter =
          'showMedia=false' +
          ';creatorId=' + this.userInfo.id +
          ';projectName=' + this.searchName
      } else if (this.fanwei === 2) {
        this.tableQuery.filter =
          'showMedia=false' +
          ';creatorId=' + this.userInfo.id +
          ';all=1' +
          ';projectName=' + this.searchName
      }
      listProject(this.tableQuery).then((res) => {
        this.tableData = res.data.data.data
        this.tableData.aaData.forEach(m => {
          m.checkd = false
        })
        this.loading = false
      }).catch(reason => {
        this.loading = false
      })
    },
    handleChange (val) {
      this.val = val
    },
    handleCurrentChange (val) {
      if (val !== null && val !== '') {
        this.tableData.aaData.forEach(m => {
          if (m.id === val.id) {
            m.checkd = true
            this.handleChange(m)
          } else {
            m.checkd = false
          }
        })
      }
    },
    cancel () {
      this.$emit('chooseCancel')
    },
    ok () {
      if (this.val.id === '0') {
        this.$notify({
          title: '警告',
          message: '必须选择',
          type: 'warning'
        })
      } else {
        this.$emit('chooseOk', this.val)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/choose_proj/index.vue